import * as debug from "@otto-ec/global-resources/debug";

export function logger<N extends string>(namespace: string): debug.Debug<N> {
  if (typeof debug.logger === "function") {
    return debug.logger(namespace) as debug.Debug<N>;
  }

  if (import.meta.env.DEV) {
    return console as unknown as debug.Debug<N>;
  }

  return new Proxy({} as debug.Debug<N>, {
    get(_, prop) {
      if (prop === "scope") {
        return logger;
      }
      return () => {};
    },
  });
}
